import { render, staticRenderFns } from "./EducationForm.vue?vue&type=template&id=388e4d18&"
import script from "./EducationForm.vue?vue&type=script&lang=js&"
export * from "./EducationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports